export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11783.ec162753.jpg";